export enum FormGroupModifier {
  NARROW = '_narrow',
  DISABLED = '_disabled',
  HAS_ERROR = '_hasError',
  ACTIVE = '_active',
}
